export default __webpack_public_path__ + "static/media/icon-arrow-up.ad6abfd0.webp";